import script from "./SiliconForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SiliconForm.vue?vue&type=script&setup=true&lang=js"

import "./SiliconForm.vue?vue&type=style&index=0&id=7e37c91c&lang=css"

const __exports__ = script;

export default __exports__